import "./home.scss";
require.context("./images", true);

import "./carousel.js";
